<template lang="pug">
#App.gradientbg(:style="`--bg: ${backgrounds[gradient]};`")
  div.content
    GridOverlay(v-show="this.$store.state.showGrid" opacity="0.3")
    Sidebar(:currentPage="currentPage")
    CartState
    transition(name="cart"): Cart(v-show="this.$store.state.cartIsOpen")
  router-view.view(@navigationName="handleCreate")
</template>

<script>
import Sidebar from '@/components/Sidebar'
import GridOverlay from '@/components/GridOverlay'
import Cart from '@/components/Cart'
import CartState from '@/components/CartState'
import { TimelineLite, Power4 } from 'gsap'

// TODO: cambiar YTxVimeo y presu CMS

export default {
  components: { Sidebar, GridOverlay, Cart, CartState },
  data() {
    return {
      gradient: null,
      currentPage: '',
      backgrounds: [
        'url(https://res.cloudinary.com/dgsgrfpwk/image/upload/v1594379396/gradientsMaria/Maria-Cerdan_Gradient_02_abd69k.svg)',
        'url(https://res.cloudinary.com/dgsgrfpwk/image/upload/v1594379393/gradientsMaria/Maria-Cerdan_Gradient_01_frqejh.svg)',
        'url(https://res.cloudinary.com/dgsgrfpwk/image/upload/v1594379393/gradientsMaria/Maria-Cerdan_Gradient_03_tfafq8.svg)',
        'url(https://res.cloudinary.com/dgsgrfpwk/image/upload/v1594379393/gradientsMaria/Maria-Cerdan_Gradient_04_wx9ydl.svg)',
        'url(https://res.cloudinary.com/dgsgrfpwk/image/upload/v1594379393/gradientsMaria/Maria-Cerdan_Gradient_05_fw1m22.svg)'
      ]
    }
  },
  methods: {
    handleCreate(value) {
      this.currentPage = value
    },
    getNewRandomIndex() {
      this.gradient = Math.floor(Math.random() * this.backgrounds.length)
    }
  },
  created() {
    this.getNewRandomIndex()
  },
  mounted() {
    this.$store.commit('setColors', {
      bg: getComputedStyle(document.documentElement).getPropertyValue('--c-bg'),
      txt: getComputedStyle(document.documentElement).getPropertyValue(
        '--c-white'
      )
    })
    window.addEventListener('touchstart', () => {
      this.$store.commit('userHasTouch')
    })
    const tl = new TimelineLite()

    tl.staggerFrom('.gradientbg', 0.1, {
      opacity: 0,
      ease: Power4.easeOut
    })
      .from('.content', 1, { opacity: 0, ease: Power4.easeOut, delay: 0.5 })
      .from('.view', 0.5, {
        opacity: 0,
        ease: Power4.easeOut,
        delay: 0.2
      })
  }
}
</script>

<style lang="scss">
@import './assets/fonts/font';

body,
html {
  margin: 0;
  padding: 0;
  font-family: 'Manrope', Arial, Helvetica, sans-serif;
  font-display: swap;
  font-size: $fs;
  overscroll-behavior: none;
  font-weight: normal;
}

.cart {
  &-leave-active,
  &-enter-active {
    transition: 1s $ease-out;
  }

  &-leave-to,
  &-enter {
    transform: translateX(100%);
  }
}

/* .gradientbg {
  height: 100%;
  overflow: auto;
} */

.gradientbg {
  --gradient: '';
}

.gradientbg:before {
  content: '';
  position: fixed;
  background-image: var(--bg);
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: -11;
  background-size: cover;

  @media screen and (max-width: 1023px) {
    -webkit-animation-name: gradientMobile;
    -webkit-animation-duration: 17s;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-timing-function: ease;
    animation-name: gradientMobile;
    animation-duration: 17s;
    animation-iteration-count: infinite;
    animation-timing-function: ease;
  }
  @media screen and (min-width: 1024px) {
    -webkit-animation-name: gradientDesktop;
    -webkit-animation-duration: 14s;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-timing-function: ease;

    animation-name: gradientDesktop;
    animation-duration: 14s;
    animation-iteration-count: infinite;
    animation-timing-function: ease;
  }
}

@-webkit-keyframes gradientDesktop {
  0% {
    -webkit-transform: scale(1);
    -webkit-background-position: 0% 0%;
  }
  25% {
    -webkit-transform: scale(1.9);
    -webkit-background-position: -50 75%;
  }
  50% {
    -webkit-transform: scale(2);
    -webkit-background-position: 75% 100%;
  }
  75% {
    -webkit-transform: scale(2);
    -webkit-background-position: 100% 75%;
  }

  100% {
    -webkit-transform: scale(1);
    -webkit-background-position: 0% 0%;
  }
}

@-webkit-keyframes gradientMobile {
  0% {
    transform: scale(1.1);
    background-position: 0% 0%;
  }
  25% {
    background-position: 0 25%;
  }
  50% {
    transform: scale(1.3);
    background-position: 25% 50%;
  }
  75% {
    background-position: 50% 25%;
  }
  100% {
    transform: scale(1.1);
    background-position: 0% 0%;
  }
}
</style>
